import type { TooltipComponentFormatterCallbackParams } from "echarts";

/**
 * Ein Serieneintrag im ECharts-Tooltip.
 *
 * ECharts liefert je nach Trigger einen einzelnen Eintrag oder eine Liste
 * ({@link TooltipComponentFormatterCallbackParams}). Gelesen werden in m1member durchgehend nur die
 * Felder unten — dieser Typ hält das fest, statt an jeder Stelle `any` zu schreiben.
 */
export type EChartsTooltipParam = {
  /** Wert auf der Kategorieachse (bei `trigger: "axis"`). */
  axisValue?: unknown;
  /** Name der Serie, zu der dieser Eintrag gehört. */
  seriesName?: unknown;
  /** Der Datenwert. */
  value?: unknown;
  /** Vorgefertigtes Farbkästchen als HTML-Schnipsel. */
  marker?: unknown;
  /** Anteil in Prozent (Kreisdiagramme). */
  percent?: unknown;
  /** Bezeichnung des Datenpunkts (Kreisdiagramme). */
  name?: unknown;
  /** Rohdatenpunkt, z. B. `[x, y, wert]` bei Heatmaps. */
  data?: unknown;
};

/**
 * Normalisiert die Tooltip-Parameter auf eine Liste.
 *
 * Damit braucht keine Aufrufstelle mehr eine eigene `Array.isArray`-Abfrage — und keine einen Cast.
 */
export function asTooltipParams(params: TooltipComponentFormatterCallbackParams): EChartsTooltipParam[] {
  if (Array.isArray(params)) return params as EChartsTooltipParam[];
  return params ? [params as EChartsTooltipParam] : [];
}
